var initialState = [];
import PerkConstants from '../../constants/PerkConstants';

export default function perks(state = initialState, action) {
  switch (action.type) {
    case PerkConstants.PERK_GET_LIST:
      return action.payload;
    case PerkConstants.PERK_POST:
      return [
        ...state,
        action.payload
      ];
    case PerkConstants.PERK_PUT:
      var newState = [...state];
      state.forEach((item, index) => {
        if(item.id === action.payload.id) {
          newState[index] = action.payload;
        }
      });
      return [...newState];
    case PerkConstants.PERK_DELETE:
      return [
        ...state.filter(city => city.id !== action.payload)
      ];
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/perks.js
 **/